import { formatearEtiquetaPeriodo } from '../../../utils/analiticaPos'
import { formatearKilosPos, formatearMontoPos } from '../../../utils/pos'
import { GraficoBarrasVerticales } from './GraficoBarras'

function Bloque({ titulo, children }) {
  return (
    <div className="rounded-2xl border border-slate-200 bg-white p-5 shadow-sm">
      <h3 className="mb-4 text-base font-bold text-slate-900">{titulo}</h3>
      {children}
    </div>
  )
}

const ETIQUETAS_GRANULARIDAD = {
  day: 'por día',
  week: 'por semana',
  month: 'por mes',
}

function TendenciasAnalitica({ tendencia }) {
  if (!tendencia || tendencia.length === 0) {
    return (
      <div className="rounded-2xl border border-slate-200 bg-white p-10 text-center shadow-sm">
        <p className="text-slate-500">No hay ventas POS para los filtros seleccionados.</p>
      </div>
    )
  }

  const granularidad = tendencia[0].granularidad
  const sufijo = ETIQUETAS_GRANULARIDAD[granularidad] || ''

  const puntos = tendencia.map((t) => ({
    etiqueta: formatearEtiquetaPeriodo(t.periodo, granularidad),
    monto: t.monto_vendido,
    kilos: t.kilos_vendidos,
    precio: t.precio_promedio_kg || 0,
    acumulado: t.monto_acumulado,
  }))

  return (
    <div className="space-y-6">
      <Bloque titulo={`Ventas en el tiempo (${sufijo})`}>
        <GraficoBarrasVerticales
          datos={puntos.map((p) => ({ etiqueta: p.etiqueta, valor: p.monto }))}
          formatearValor={formatearMontoPos}
        />
      </Bloque>

      <Bloque titulo={`Kilos vendidos en el tiempo (${sufijo})`}>
        <GraficoBarrasVerticales
          datos={puntos.map((p) => ({ etiqueta: p.etiqueta, valor: p.kilos }))}
          formatearValor={formatearKilosPos}
          color="bg-sky-500"
        />
      </Bloque>

      <Bloque titulo={`Precio promedio/kg en el tiempo (${sufijo})`}>
        <GraficoBarrasVerticales
          datos={puntos.map((p) => ({ etiqueta: p.etiqueta, valor: p.precio }))}
          formatearValor={formatearMontoPos}
          color="bg-amber-500"
        />
      </Bloque>

      <Bloque titulo="Venta acumulada del período">
        <GraficoBarrasVerticales
          datos={puntos.map((p) => ({ etiqueta: p.etiqueta, valor: p.acumulado }))}
          formatearValor={formatearMontoPos}
          color="bg-emerald-700"
        />
      </Bloque>
    </div>
  )
}

export default TendenciasAnalitica
